export const notFound = {
  path: "*",
  redirect: "/"
};
